<template>
    <form @submit.prevent="onSubmit(id ? 'update' : 'create')" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4>
            </div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{ errors }}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{ key }}: {{ error }}
                </p>
            </div>
        </div>
        <br />
        <div class="mb-5">
            <label>Pmta Relays:</label>
            <treeselect placeholder="Select Pmta Relay(s)" v-model="pmtaRelays" :multiple="true"
                :options="pmtaRelayList" value-format="object" v-show="!id" />
            <input v-model="pmtaSpeed.pmtaRelay.smtpHost" type="text" class="form-control" disabled v-show="id">
            <div v-if="$v.pmtaRelays.$error">
                <div class="text-danger" v-if="!$v.pmtaRelays.required">Pmta Relay is required</div>
            </div>
        </div>
        <div class="mb-5">
            <label>Mail Service:</label>
            <treeselect placeholder="Select Mail Service" v-model="mailProvider" :multiple="false"
                :options="providerList" :load-options="loadProviderList" v-show="!id" />
            <input v-model="pmtaSpeed.mailProvider.name" type="text" class="form-control" disabled v-show="id">
            <div v-if="$v.mailProvider.$error">
                <div class="text-danger" v-if="!$v.mailProvider.required">Mail Service is required.</div>
            </div>
        </div>
        <div class="mb-5">
            <label>Speed:</label>
            <input v-model="speed" type="text" class="form-control">
        </div>

        <div class="form-group text-center p-b-20  p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                    v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Treeselect from '@riophae/vue-treeselect';
import Preloader from '../../components/Preloader';
import PmtaSpeedService from '../../services/PmtaSpeedService';
import PmtaRelayGroupService from '../../services/PmtaRelayGroupService';
import PmtaRelayService from '../../services/PmtaRelayService';
import MailProviderService from '../../services/MailProviderService';

export default {
    name: 'PmtaSpeed',
    props: ['id'],
    components: { Treeselect, Preloader },
    data() {
        return {
            errors: {},
            showFailureMessage: false,
            submitting: false,
            relayGroupList: null,
            pmtaRelayList: [],
            providerList: null,
            pmtaRelays: null,
            mailProvider: null,
            speed: '',
            pmtaSpeed: {
                pmtaRelay: { smtpHost: null },
                mailProvider: { name: null },
            },
        }
    },
    mounted() {
        if (this.id) {
            PmtaSpeedService.getPmtaSpeed(this.id).then(response => {
                this.pmtaSpeed.pmtaRelay = response.data.pmtaRelay;
                this.pmtaSpeed.mailProvider = response.data.provider;
                this.speed = response.data.localValue;
                this.$emit('hidePreloader', true);
            });
        } else {
            this.loadPmtaRelayList();
        }
    },
    validations() {
        return {
            pmtaRelays: { required },
            mailProvider: { required },
        }
    },
    methods: {
        loadProviderList({ callback }) {
            MailProviderService.getProviderSelect().then(response => {
                this.providerList = response.data['hydra:member'].map(provider => {
                    return { id: provider.id, label: provider.name }
                });
                callback();
            });
        },
        loadPmtaRelayList() {
            PmtaRelayGroupService.getGroupSelect().then(response => {
                this.relayGroupList = response.data['hydra:member'].map(group => {
                    return { id: group.id, label: group.name }
                });
                this.pmtaRelayList = [];
                this.relayGroupList.map(group => {
                    PmtaRelayService.getRelaysByGroup(group.id).then(response => {
                        this.pmtaRelayList.push({
                            id: '_' + group.id,
                            label: group.label,
                            children: response.data['hydra:member'].map(relay => {
                                return { id: relay.id, label: relay.smtpHost }
                            })
                        });
                    });
                });
            });
        },
        onSubmit(action) {
            if (action === 'update') {
                this.submitting = true;
                let modifiedData = { localValue: null, localTime: this.moment().utc().format() };
                modifiedData.localValue = this.speed;
                PmtaSpeedService.updatePmtaSpeed(this.id, JSON.stringify(modifiedData)).then(response => {
                    if (response.status === 200) {
                        this.$router.push({ name: 'pmtaSpeeds' });
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                }).catch(error => {
                    this.submitting = false;
                    this.errors = error.response.data.error;
                    this.showFailureMessage = true;
                });
                return;
            }

            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.submitting = true;

            let rcpnts = this.pmtaRelays.map((parent) => {
                if (parent.hasOwnProperty('children')) {
                    return parent.children;
                } else {
                    return parent;
                }
            });
            rcpnts = rcpnts.flat();

            let data = new FormData();
            data.append('pmtaRelays', JSON.stringify(rcpnts));
            data.append('mailProvider', JSON.stringify(this.mailProvider));
            data.append('speed', this.speed);
            PmtaSpeedService.createPmtaSpeed(data).then(response => {
                if (response.status === 200) {
                    this.$router.push({ name: 'pmtaSpeeds' });
                }
                this.submitting = false;
                this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                this.showFailureMessage = true;
            }).catch(error => {
                this.submitting = false;
                this.errors = error.response.data.error;
                this.showFailureMessage = true;
            });
        },
    }
}
</script>

<style scoped></style>
